import { Button as FloraButton, ModalFooter, styled } from '@grupoboticario/flora-react';
import { theme } from 'ui/theme';

export const Button = styled(FloraButton, {
  fontFamily:
    'Space Grotesk, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
  background: `${theme.colors.action.navigation.standard.static} !important`,
  '&:focus-visible': {
    boxShadow: 'none',
  },
});

export const IRWhatsAppButton = styled(FloraButton, {
  display: 'inline-flex',
  alignContent: 'center',
  justifyContent: 'center',
  boxShadow: `inset 0 0 0 1px ${theme.colors.action.navigation.standard.static}`,
  padding: `${theme.space['4']}`,
  borderRadius: `${theme.radii.small}`,
  '&:hover': {
    background: `${theme.colors.action.navigation.standard.static}`,
    textDecoration: 'none !important',
    color: `${theme.colors.action.navigation.alt.static}`,
  },
});

export const ContentModal = styled('div', {
  fontFamily:
    'DM Sans,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol',
});

export const ModalFooterMobile = styled(ModalFooter, {
  flexDirection: 'column',
});
